// src/component/EmailModal.js
import React, { useState,useEffect } from 'react';
import Modal from 'react-modal';
import styles from './HospitalEmailModal.module.css';
import Loader from './Loader';


Modal.setAppElement('#root');

function HospitalEmailModal({ isOpen, onRequestClose, test, SendEmail }) {
  const [recipientEmail, setRecipientEmail] = useState(''); // State for managing recipient email input
  const [loading, setLoading] = useState(false);
    const [emailType, setEmailType] = useState("");
   

  const handleEmailChange = (e) => {
    setRecipientEmail(e.target.value); // Handle change in email input
  };
    const handleTypeChange = (event) => {
    setEmailType(event.target.value);
  
      if (event.target.value === "doctor") {
    setRecipientEmail(test[0].SalesEntry.PrimaryPhysicianEmailId || ""); // doctorEmail should come from your data
  } else if (event.target.value=== "patient") {
    setRecipientEmail( test[0].SalesEntry.PatientEmailID|| ""); // patientEmail should come from your data
  }
  };

  const handleSubmit = async () => {
    setLoading(true);
    // Gather all report URLs from tests
    const reportUrls = test.map(test => test.reportUrl).filter(url => url); // Filter to include only valid URLs
    await SendEmail(recipientEmail, test, reportUrls,emailType); // Send email with report URLs
    setLoading(false);
    onRequestClose(); // Close the modal
    
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={styles["modal-content"]}
      overlayClassName="modal-overlay"
    >
      {loading && <div className="loader"></div>}
      <h2>Send Email</h2>
      <button className={styles['close-button']} onClick={onRequestClose}>×</button>
      <hr />
      <form className="modal-form">
        <div className="form-group">
          <label>Recipient Email:</label>
          <input 
            type="email" 
            value={recipientEmail} 
            onChange={handleEmailChange} 
            required 
          />
        </div>
         {/* Radio buttons for selecting recipient type */}
           {/* Radio Button Group */}
        <div className={styles["form-group"]}>
          <label className={styles["form-label"]}>Send To:</label>
          <div className={styles["radio-group"]}>
            <label className={styles["radio-label"]}>
              <input
                type="radio"
                value="doctor"
                checked={emailType === "doctor"}
                onChange={handleTypeChange}
              />
              Doctor
            </label>
            <label className={styles["radio-label"]}>
              <input
                type="radio"
                value="patient"
                checked={emailType === "patient"}
                onChange={handleTypeChange}
              />
              Patient
            </label>
          </div>
        </div>
        <div className={styles['form-group']}>
          <label>Reports</label>
          {test.length > 0 ? (
            test.map((test, index) => (
              <div key={index}>
                {test.reportUrl ? (
                  <a href={test.reportUrl} target="_blank" rel="noopener noreferrer">
                    View Report {index + 1} - {test.test}
                  </a>
                ) : (
                  <p>No report uploaded for {test.test}.</p>
                )}
              </div>
            ))
          ) : (
            <p>No reports available.</p>
          )}
        </div>
      </form>
      <button className={styles['submit-button']} disabled={loading}  onClick={handleSubmit} style={{cursor:loading?'not-allowed':'pointer',opacity:loading?0.6:1}}>Send</button>
    </Modal>
  );
}

export default HospitalEmailModal;
